import { cn } from '@/lib/utils';

/** Card / panel: liquid glass peste video sau fundal alb clasic */
export function glassCardClass(overVideo: boolean, lightClass = 'bg-white') {
  return cn(overVideo ? 'custom-liquid-glass' : lightClass);
}

/** CTA principal — glass pill, text alb (fără fundal alb solid) */
export function appleCtaPrimaryClass(className?: string) {
  return cn(
    'inline-flex min-w-[200px] items-center justify-center gap-2 rounded-full px-8',
    'h-12 md:h-[52px] text-[15px] md:text-[17px] font-medium tracking-[-0.02em] text-white',
    'bg-white/20 backdrop-blur-xl',
    'shadow-[0_4px_24px_rgba(0,0,0,0.28),inset_0_1px_0_rgba(255,255,255,0.22)]',
    'ring-1 ring-inset ring-white/35',
    'hover:bg-white/26 hover:ring-white/45 active:bg-white/16 active:scale-[0.98]',
    'transition-[background-color,transform,box-shadow] duration-200 ease-out',
    '[touch-action:manipulation]',
    className
  );
}

/** Temă Cloudflare Turnstile — dark pe fundal video / glass */
export function turnstileWidgetTheme(overVideo: boolean): 'light' | 'dark' | 'auto' {
  return overVideo ? 'dark' : 'auto';
}

/** Navbar dark glass — susul paginii (home, peste video) */
export const appleNavShellHeroClass =
  'border-b border-white/10 bg-[rgba(8,6,14,0.78)] shadow-[0_8px_28px_rgba(0,0,0,0.38)] backdrop-blur-2xl supports-[backdrop-filter]:bg-[rgba(8,6,14,0.68)]';

/** Navbar dark glass — după scroll sau pagini interne */
export const appleNavShellSolidClass =
  'border-b border-white/10 bg-[rgba(8,6,14,0.9)] shadow-[0_10px_36px_rgba(0,0,0,0.45)] backdrop-blur-2xl supports-[backdrop-filter]:bg-[rgba(8,6,14,0.82)]';

/** Pill contact navbar — glass pe fundal video întunecat */
export function appleNavContactPillClass(className?: string) {
  return cn(
    'inline-flex items-center justify-center gap-1.5 rounded-full px-3.5 py-2',
    'text-[13px] font-medium tracking-[-0.02em] text-white whitespace-nowrap',
    'bg-white/[0.12] backdrop-blur-xl',
    'shadow-[0_2px_16px_rgba(0,0,0,0.25),inset_0_1px_0_rgba(255,255,255,0.2)]',
    'ring-1 ring-inset ring-white/25',
    'hover:bg-white/[0.18] hover:ring-white/35 active:bg-white/10 active:scale-[0.98]',
    'transition-[background-color,transform,box-shadow] duration-200 ease-out',
    '[touch-action:manipulation]',
    className
  );
}

/** Panou cookie consent — liquid glass (banner + modal preferences) */
export function cookieConsentDarkPanelClass(className?: string) {
  return cn(
    'custom-liquid-glass cookie-consent-panel text-white',
    'shadow-[0_24px_80px_rgba(0,0,0,0.45),inset_0_1px_0_rgba(255,255,255,0.1)]',
    'ring-1 ring-inset ring-white/[0.08]',
    className
  );
}

/** Secțiune interioară modal cookie — fără border vizibil, doar depth subtil */
export function cookieConsentDarkSectionClass(className?: string) {
  return cn(
    'cookie-consent-inner-section rounded-[18px] border-0',
    'bg-white/[0.035]',
    'shadow-[inset_0_1px_0_rgba(255,255,255,0.07)]',
    className
  );
}

/** Separator discret în modal cookie */
export function cookieConsentDarkDividerClass(className?: string) {
  return cn('h-px w-full shrink-0 border-0 bg-white/[0.06]', className);
}

/** CTA secundar — glass discret pe fundal întunecat */
export function appleCtaSecondaryClass(className?: string) {
  return cn(
    'inline-flex items-center justify-center gap-2 rounded-full px-8',
    'h-12 md:h-[52px] text-[15px] md:text-[17px] font-medium tracking-[-0.02em] text-white/90',
    'bg-white/8 backdrop-blur-md ring-1 ring-inset ring-white/20',
    'hover:bg-white/12 hover:text-white active:bg-white/6 active:scale-[0.98]',
    'transition-[background-color,transform,color] duration-200 ease-out',
    '[touch-action:manipulation]',
    className
  );
}
